/* global siteurl: false */

import TweenMax from 'gsap';
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();
window.__forceSmoothScrollPolyfill__ = true;

(function () {
    'use strict';
    // get body element to measure locations on page and detect breakpoint
    const bodyEl = document.querySelector('body');
    // const htmlEl = document.querySelector('html');
   
    //initial scroll position
    // var scrollPos = 0;

    // get all the sections on the page
    const sections = document.querySelectorAll('.section-mother');

    // create the background element and stick it in the dom
    let bgMother = document.createElement('div');
    addClass(bgMother, 'background-mother');
    document.body.appendChild(bgMother);

    // make a new ul element so we can start building nav
    const hotUl = document.createElement('ul');
    // add some classes
    hotUl.setAttribute('class', 'hotlinks-list');

    // build array of backgrounds - this should include where the background is "none"
    let backgrounds = [];
    if (sections.length) {
        for (let i = 0; i < sections.length; i++) {
            const s = sections[i];
            backgrounds.push(getComputedStyle(s)['backgroundImage']);

            // we need an ID on each section, pull it from predefined stuff in the blocks
            const classList = s.className.split(' ');
            if(classList.length) {
                for (let c = 0; c < classList.length; c++) {
                    const className = classList[c];
                    if (className.includes('id-')) {
                        // removeClass(c, className);
                        const cleanClassname = className.replace('id-', '');
                        s.setAttribute('id', cleanClassname);
                    }
                }
            }

            // add the down arrow to the one with .down-arrow and attach click event
            if(hasClass(s, 'down-arrow')) {
                let downArrow = document.createElement('div');
                addClass(downArrow, 'i-am-the-arrow');
                s.appendChild(downArrow);
                s.addEventListener('click', function(){
                    hashScroll('#about-us');
                });
            }
        }
    }

    // handle link clicks
    const links = document.querySelectorAll('a');
    if (links.length) {
        for (let l = 0; l < links.length; l++) {
            const link = links[l];
            link.addEventListener('click', function (e) {
                e.preventDefault();

                // setTimeout(() => {
                //     window.handleStaggerIns()
                // }, 250);

                const href = link.getAttribute('href');
                
                if (href.includes('#')) {
                    let urlParts = href.split('#');
                    let hash = '#'+urlParts[1];                    

                    let hashEl = document.querySelector(hash);
                    if (hashEl) {
                        rmNavClasses();
                        hashScroll(hash);
                    } else {
                        rmNavClasses();
                        window.location.href = href;
                    }
                } else {
                    rmNavClasses();
                    window.location.href = href;
                }


            });
        }
    }

    function rmNavClasses() {
        // if (hasClass(htmlEl, 'touch') && hasClass(link.parentNode, 'menu-item')) {
            const target = document.querySelector('.cw-nav-ul');

            if (target) {
                removeClass(target, 'open');
            }

            // if (hasClass(bodyEl, 'mobile-nav-open')) {
                removeClass(bodyEl, 'mobile-nav-open');
            // } else {
                // addClass(bodyEl, 'mobile-nav-open');
            // }
        // }
    }

    // build hotlink menu
    function hotlinkItUp() {
        // used to measure locations of elements
        const bodyRect = bodyEl.getBoundingClientRect();

        // get the hot link container element
        const hotlinksMother = document.querySelector('.hotlinks-mother');

        // if we have a hot link mother, do the things
        if (hotlinksMother) {
            // get position of hot link mother
            let hotlinksMotherPos = hotlinksMother.getBoundingClientRect();
            const hotlinksMotherPosTop = Math.round(hotlinksMotherPos.top - bodyRect.top);

            // set into global scope to get in function later
            window.hotlinksMotherPosTop = hotlinksMotherPosTop;

            // get the child elements to get ids and measure stuff
            const hotlinks = hotlinksMother.querySelector('.hotlinks');
            const mainNav = document.querySelector('.cw-nav-ul');

            // get all the elements!
            const allTags = mainNav.querySelectorAll('.menu-item');

            // add just the ones with the correct key (cwhl) to a list so we can do stuff to em
            let ids = [];
            for (let tg = 0; tg < allTags.length; tg++) {
                const link = allTags[tg];
                const anchor = link.querySelector('a');
                const href = anchor.getAttribute('href');
                ids.push(href);
            }

            // always make sure we have something in the array so we don't get errors 
            if (ids.length) {
                for (let i = 0; i < ids.length; i++) {
                    const id = ids[i];
                    if (!validURL(id)) {
                        // build a nav item for each id
                        let idEl = document.querySelector(id);
                        addClass(idEl, 'section-title');

                        // get the actual title
                        const titleEl = idEl.querySelector('.sect-title');
                        let idName = titleEl.innerHTML;

                        // continue building nav
                        let hotLi = document.createElement('li');
                        hotLi.setAttribute('class', 'hotlink');

                        let hotA = document.createElement('a');
                        hotA.setAttribute('href', id);
                        hotA.innerHTML = idName;

                        // now that all the nav elements are built, attatch a click listener that will scroll to the position we measured above
                        hotA.addEventListener('click', function (e) {
                            e.preventDefault();
                            hashScroll(id);
                        });

                        // and then put all the elements together
                        hotLi.appendChild(hotA);
                        hotUl.appendChild(hotLi);
                    }
                }

                // and stick into the <ul> element
                hotlinks.appendChild(hotUl);
            }
        }

        // auto scroll to location.hash
        hashScroll();
    }

    // handle current state based on what section is visible
    let visibleURLs = [];
    let currentURL = '';
    const menuItems = document.querySelectorAll('.menu-item');
	function handleHotlinksScroll() {
        const hotlinksMother = document.querySelector('.hotlinks-mother');

        if (hotlinksMother) {
            let pos = window.scrollY;

            if (pos >= window.hotlinksMotherPosTop) {
                addClass(hotlinksMother, 'down');
            } else {
                removeClass(hotlinksMother, 'down');
            }

            const hotlinks = hotlinksMother.querySelectorAll('.hotlink');
            let hlInView = false;

            if(hotlinks.length) {
                for (let h = 0; h < hotlinks.length; h++) {
                    const hlink = hotlinks[h];
                    const hAnchor = hlink.querySelector('a');
                    const hash = hAnchor.getAttribute('href');
                    const url = siteurl + hash.replace('#', '/');
                    const hlinkTarget = document.querySelector(hash);
                    const staggerIns = hlinkTarget.querySelectorAll('.stagger-in');

                    if (doYouSee(hlinkTarget)) {
                        hlInView = true;

                        if(staggerIns) {
                            TweenMax.staggerTo(staggerIns, .5, { y: 0, opacity: 1 }, .125);
                        }

                        let currentHlink = document.querySelector('.current-hlink');
                        if(currentHlink) {
                            removeClass(currentHlink, 'current-hlink');
                        }
                        addClass(hlink, 'current-hlink');

                        if (!visibleURLs.includes(url)) {
                            visibleURLs.push(url);
                        }

                        if (visibleURLs.length > 1) {
                            currentURL = visibleURLs[1];
                        } else {
                            currentURL = visibleURLs[0];
                        }

                        window.history.pushState({}, '', currentURL);

                        if (menuItems.length) {
                            for (let mi = 0; mi < menuItems.length; mi++) {
                                const menuItem = menuItems[mi];
                                const menuA = menuItem.querySelector('a');
                                if(menuA.getAttribute('href').includes(hash)) {
                                    addClass(menuItem, 'current-menu-item');
                                } else {
                                    removeClass(menuItem, 'current-menu-item');
                                }
                            }
                        }
                    } else {
                        // hlInView = false;

                        if (staggerIns) {
                            TweenMax.set(staggerIns, { y: 15, opacity: 0 });
                        }

                        const index = visibleURLs.indexOf(url);
                        if (index > -1) {
                            visibleURLs.splice(index, 1);
                        }

                        removeClass(hlink, 'current-hlink');
                    }
                }
            }

            if (hlInView) {
                addClass(hotUl, 'showing');
            } else {
                window.history.pushState({}, '', siteurl);
                removeClass(hotUl, 'showing');
            }
        }
    }
    
    // auto scroll to location.hash
    function hashScroll(hash) {
        if(!hash) {
            hash = window.location.hash;
        }

        if(hash && hash != '#') {
            window.location.href = hash;

            let slug = hash.replace('#', '/');
            // window.history.replaceState({}, '', siteurl+slug);
            window.history.pushState({}, '', siteurl + slug);
        } else {
            return;
        }
    }

    // do you see the section?
    function doYouSee(el, halfway = true) {
        var top = el.offsetTop;
        var height = el.offsetHeight;

        while (el.offsetParent) {
            el = el.offsetParent;
            top += el.offsetTop;
        }

        let winY = window.pageYOffset;
        let winH = window.innerHeight;

        if(halfway) {
            winH = (window.innerHeight / 2);
        }
        
        return (
            top < (winY + winH)
            &&
            (top + height) > winY
        );
    }

    //set the background based on visible section
    function setBG(dir) {
        if (sections.length && backgrounds) {
            let visibles = [];

            for (let s = 0; s < sections.length; s++) {
                const sect = sections[s];
                if (doYouSee(sect)) {
                    visibles.push(s);
                } else {
                    const index = visibles.indexOf(s);
                    if (index > -1) {
                        visibles.splice(index, 1);
                    }
                }
            }

            visibles.sort();

            let bgid = 0;

            if (dir == 'up') {
                bgid = firstInArray(visibles);
            } else if (dir == 'down') {
                bgid = visibles[visibles.length - 1];
            }

            for (let sn = 0; sn < sections.length; sn++) {
                const sectn = sections[sn];
                removeClass(sectn, 'current');
            }

            if (!hasClass(sections[bgid], 'current')) {
                addClass(sections[bgid], 'current');
            }

            bgMother.style.backgroundImage = backgrounds[bgid];
        }
    }

    const headerEl = document.querySelector('[role="banner"]');
    const headerEl_h = headerEl.offsetHeight;

    function updateHeaderClasses(dir) {
        if (window.pageYOffset > headerEl_h) {
            addClass(headerEl, 'stuck');
        } else {
            removeClass(headerEl, 'stuck');
        }

        if (dir == 'up') {
            addClass(headerEl, 'showit');
        } else {
            removeClass(headerEl, 'showit');
        }
    }

    /*!
     * Run a callback function after scrolling has stopped
     * (c) 2017 Chris Ferdinandi, MIT License, https://gomakethings.com
     * @param  {Function} callback The function to run after scrolling
     */
    // var scrollStop = function (callback) {
    //     // Make sure a valid callback was provided
    //     if (!callback || typeof callback !== 'function') return;

    //     // Setup scrolling variable
    //     var isScrolling;

    //     // Listen for scroll events
    //     window.addEventListener('scroll', function () {
    //         // Clear our timeout throughout the scroll

    //         window.clearTimeout(isScrolling);
    //         // Set a timeout to run after scrolling ends

    //         isScrolling = setTimeout(function () {
    //             // Run the callback
    //             callback();
    //         }, 66);
    //     }, false);
    // };

    // get that window up to speed    
    window.addEventListener('scroll', function () {
        let dir = 'down';
        // detects new state and compares it with the new one
        // if ((document.body.getBoundingClientRect()).top > scrollPos) {
        //     dir = 'up';
        // } else {
        //     dir = 'down';
        // }

        // // saves the new position for iteration.
        // scrollPos = (document.body.getBoundingClientRect()).top;

        debounce(setBG(dir), 250);
        debounce(updateHeaderClasses(dir), 250);
        debounce(handleHotlinksScroll(), 250);

        // window.handleStaggerIns();
    });

    window.onload = function () {
        // fire this off on load to calculate positions correctly if, for example, the page is scrolled part way down and refreshed or something
        handleHotlinksScroll();

        // wait till everything is loaded before firing this up so we can get correct height calculations
        hotlinkItUp();

        // load first background
        setBG('down');

        // run the thing
        hashScroll();

        // run animations
        // window.handleStaggerIns();
    };

    // utilities
    // https://www.w3resource.com/javascript-exercises/javascript-array-exercise-3.php
    function firstInArray (array, n) {
        if (array == null)
            return void 0;
        if (n == null)
            return array[0];
        if (n < 0)
            return [];
        return array.slice(0, n);
    }

    function removeClass(el, className) {
        if (el.classList)
            el.classList.remove(className);
        else
            el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }

    function addClass(el, className) {
        if (el.classList)
            el.classList.add(className);
        else
            el.className += ' ' + className;
    }

    // http://youmightnotneedjquery.com/
    function hasClass(el, className) {
        if (el.classList) {
            return el.classList.contains(className);
        } else {
            return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
        }
    }

    // http://youmightnotneedjquery.com/
    function toggleClass(el, className) {
        if (el.classList) {
            el.classList.toggle(className);
        } else {
            let classes = el.className.split(' ');
            let existingIndex = -1;

            for (let i = classes.length; i--;) {
                if (classes[i] === className) {
                    existingIndex = i;
                }
            }

            if (existingIndex >= 0) {
                classes.splice(existingIndex, 1);
            } else {
                classes.push(className);
            }

            el.className = classes.join(' ');
        }
    }

    // https://stackoverflow.com/questions/5717093/check-if-a-javascript-string-is-a-url
    function validURL(str) {
        var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
        return !!pattern.test(str);
    }

    function debounce(func, wait, immediate) {
        let timeout;
        return function () {
            let context = this, args = arguments;
            let later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            let callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }
}());